// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/aggregate/v1/service.proto (package chalk.aggregate.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AggregateBackfillCostEstimate, AggregateBackfillJob, AggregateBackfillStatus, AggregateBackfillUserParams, AggregateBackfillWithCostEstimate, CronAggregateBackfill } from "./backfill_pb";
import { file_chalk_aggregate_v1_backfill } from "./backfill_pb";
import type { AggregateTimeSeries } from "./timeseries_pb";
import { file_chalk_aggregate_v1_timeseries } from "./timeseries_pb";
import { file_chalk_auth_v1_audit } from "../../auth/v1/audit_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { ChalkError } from "../../common/v1/chalk_error_pb";
import { file_chalk_common_v1_chalk_error } from "../../common/v1/chalk_error_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/aggregate/v1/service.proto.
 */
export const file_chalk_aggregate_v1_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_aggregate_v1_backfill, file_chalk_aggregate_v1_timeseries, file_chalk_auth_v1_audit, file_chalk_auth_v1_permissions, file_chalk_common_v1_chalk_error, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.aggregate.v1.PlanAggregateBackfillRequest
 */
export type PlanAggregateBackfillRequest = Message<"chalk.aggregate.v1.PlanAggregateBackfillRequest"> & {
  /**
   * @generated from field: chalk.aggregate.v1.AggregateBackfillUserParams params = 1;
   */
  params?: AggregateBackfillUserParams;
};

/**
 * Describes the message chalk.aggregate.v1.PlanAggregateBackfillRequest.
 * Use `create(PlanAggregateBackfillRequestSchema)` to create a new message.
 */
export const PlanAggregateBackfillRequestSchema: GenMessage<PlanAggregateBackfillRequest> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 0);

/**
 * @generated from message chalk.aggregate.v1.PlanAggregateBackfillResponse
 */
export type PlanAggregateBackfillResponse = Message<"chalk.aggregate.v1.PlanAggregateBackfillResponse"> & {
  /**
   * @generated from field: chalk.aggregate.v1.AggregateBackfillCostEstimate estimate = 2 [deprecated = true];
   * @deprecated
   */
  estimate?: AggregateBackfillCostEstimate;

  /**
   * @generated from field: repeated string errors = 4;
   */
  errors: string[];

  /**
   * @generated from field: repeated chalk.aggregate.v1.AggregateBackfillWithCostEstimate backfills = 6;
   */
  backfills: AggregateBackfillWithCostEstimate[];

  /**
   * @generated from field: string aggregate_backfill_id = 7;
   */
  aggregateBackfillId: string;
};

/**
 * Describes the message chalk.aggregate.v1.PlanAggregateBackfillResponse.
 * Use `create(PlanAggregateBackfillResponseSchema)` to create a new message.
 */
export const PlanAggregateBackfillResponseSchema: GenMessage<PlanAggregateBackfillResponse> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 1);

/**
 * @generated from message chalk.aggregate.v1.GetAggregatesRequest
 */
export type GetAggregatesRequest = Message<"chalk.aggregate.v1.GetAggregatesRequest"> & {
  /**
   * @generated from field: repeated string for_features = 1;
   */
  forFeatures: string[];
};

/**
 * Describes the message chalk.aggregate.v1.GetAggregatesRequest.
 * Use `create(GetAggregatesRequestSchema)` to create a new message.
 */
export const GetAggregatesRequestSchema: GenMessage<GetAggregatesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 2);

/**
 * @generated from message chalk.aggregate.v1.GetAggregatesResponse
 */
export type GetAggregatesResponse = Message<"chalk.aggregate.v1.GetAggregatesResponse"> & {
  /**
   * @generated from field: repeated chalk.aggregate.v1.AggregateTimeSeries series = 1;
   */
  series: AggregateTimeSeries[];

  /**
   * @generated from field: repeated string errors = 2;
   */
  errors: string[];
};

/**
 * Describes the message chalk.aggregate.v1.GetAggregatesResponse.
 * Use `create(GetAggregatesResponseSchema)` to create a new message.
 */
export const GetAggregatesResponseSchema: GenMessage<GetAggregatesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 3);

/**
 * @generated from message chalk.aggregate.v1.GetAggregateBackfillJobsRequest
 */
export type GetAggregateBackfillJobsRequest = Message<"chalk.aggregate.v1.GetAggregateBackfillJobsRequest"> & {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit: number;

  /**
   * @generated from field: string cursor = 2;
   */
  cursor: string;

  /**
   * @generated from field: optional string plan_hash = 3;
   */
  planHash?: string;

  /**
   * @generated from field: chalk.aggregate.v1.AggregateBackfillStatus init_status = 4;
   */
  initStatus: AggregateBackfillStatus;

  /**
   * @generated from field: optional string name = 5;
   */
  name?: string;
};

/**
 * Describes the message chalk.aggregate.v1.GetAggregateBackfillJobsRequest.
 * Use `create(GetAggregateBackfillJobsRequestSchema)` to create a new message.
 */
export const GetAggregateBackfillJobsRequestSchema: GenMessage<GetAggregateBackfillJobsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 4);

/**
 * @generated from message chalk.aggregate.v1.GetAggregateBackfillJobsResponse
 */
export type GetAggregateBackfillJobsResponse = Message<"chalk.aggregate.v1.GetAggregateBackfillJobsResponse"> & {
  /**
   * @generated from field: repeated chalk.aggregate.v1.AggregateBackfillJob jobs = 1;
   */
  jobs: AggregateBackfillJob[];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor: string;
};

/**
 * Describes the message chalk.aggregate.v1.GetAggregateBackfillJobsResponse.
 * Use `create(GetAggregateBackfillJobsResponseSchema)` to create a new message.
 */
export const GetAggregateBackfillJobsResponseSchema: GenMessage<GetAggregateBackfillJobsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 5);

/**
 * @generated from message chalk.aggregate.v1.GetAggregateBackfillJobRequest
 */
export type GetAggregateBackfillJobRequest = Message<"chalk.aggregate.v1.GetAggregateBackfillJobRequest"> & {
  /**
   * @generated from field: string aggregate_backfill_id = 1;
   */
  aggregateBackfillId: string;
};

/**
 * Describes the message chalk.aggregate.v1.GetAggregateBackfillJobRequest.
 * Use `create(GetAggregateBackfillJobRequestSchema)` to create a new message.
 */
export const GetAggregateBackfillJobRequestSchema: GenMessage<GetAggregateBackfillJobRequest> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 6);

/**
 * @generated from message chalk.aggregate.v1.GetAggregateBackfillJobResponse
 */
export type GetAggregateBackfillJobResponse = Message<"chalk.aggregate.v1.GetAggregateBackfillJobResponse"> & {
  /**
   * @generated from field: chalk.aggregate.v1.AggregateBackfillJob job = 1;
   */
  job?: AggregateBackfillJob;
};

/**
 * Describes the message chalk.aggregate.v1.GetAggregateBackfillJobResponse.
 * Use `create(GetAggregateBackfillJobResponseSchema)` to create a new message.
 */
export const GetAggregateBackfillJobResponseSchema: GenMessage<GetAggregateBackfillJobResponse> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 7);

/**
 * @generated from message chalk.aggregate.v1.GetCronAggregateBackfillRequest
 */
export type GetCronAggregateBackfillRequest = Message<"chalk.aggregate.v1.GetCronAggregateBackfillRequest"> & {
  /**
   * @generated from field: string cron_aggregate_backfill_id = 1 [deprecated = true];
   * @deprecated
   */
  cronAggregateBackfillId: string;

  /**
   * @generated from field: string plan_hash = 2;
   */
  planHash: string;
};

/**
 * Describes the message chalk.aggregate.v1.GetCronAggregateBackfillRequest.
 * Use `create(GetCronAggregateBackfillRequestSchema)` to create a new message.
 */
export const GetCronAggregateBackfillRequestSchema: GenMessage<GetCronAggregateBackfillRequest> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 8);

/**
 * @generated from message chalk.aggregate.v1.GetCronAggregateBackfillResponse
 */
export type GetCronAggregateBackfillResponse = Message<"chalk.aggregate.v1.GetCronAggregateBackfillResponse"> & {
  /**
   * @generated from field: chalk.aggregate.v1.CronAggregateBackfill cron_aggregate_backfill = 1;
   */
  cronAggregateBackfill?: CronAggregateBackfill;
};

/**
 * Describes the message chalk.aggregate.v1.GetCronAggregateBackfillResponse.
 * Use `create(GetCronAggregateBackfillResponseSchema)` to create a new message.
 */
export const GetCronAggregateBackfillResponseSchema: GenMessage<GetCronAggregateBackfillResponse> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 9);

/**
 * @generated from message chalk.aggregate.v1.GetActiveCronAggregateBackfillsRequest
 */
export type GetActiveCronAggregateBackfillsRequest = Message<"chalk.aggregate.v1.GetActiveCronAggregateBackfillsRequest"> & {
};

/**
 * Describes the message chalk.aggregate.v1.GetActiveCronAggregateBackfillsRequest.
 * Use `create(GetActiveCronAggregateBackfillsRequestSchema)` to create a new message.
 */
export const GetActiveCronAggregateBackfillsRequestSchema: GenMessage<GetActiveCronAggregateBackfillsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 10);

/**
 * @generated from message chalk.aggregate.v1.CronAggregateBackfillWithLatestRun
 */
export type CronAggregateBackfillWithLatestRun = Message<"chalk.aggregate.v1.CronAggregateBackfillWithLatestRun"> & {
  /**
   * @generated from field: chalk.aggregate.v1.CronAggregateBackfill cron_aggregate_backfill = 1;
   */
  cronAggregateBackfill?: CronAggregateBackfill;

  /**
   * @generated from field: chalk.aggregate.v1.AggregateBackfillJob latest_job = 2;
   */
  latestJob?: AggregateBackfillJob;
};

/**
 * Describes the message chalk.aggregate.v1.CronAggregateBackfillWithLatestRun.
 * Use `create(CronAggregateBackfillWithLatestRunSchema)` to create a new message.
 */
export const CronAggregateBackfillWithLatestRunSchema: GenMessage<CronAggregateBackfillWithLatestRun> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 11);

/**
 * @generated from message chalk.aggregate.v1.GetActiveCronAggregateBackfillsResponse
 */
export type GetActiveCronAggregateBackfillsResponse = Message<"chalk.aggregate.v1.GetActiveCronAggregateBackfillsResponse"> & {
  /**
   * @generated from field: repeated chalk.aggregate.v1.CronAggregateBackfillWithLatestRun cron_aggregate_backfills = 1;
   */
  cronAggregateBackfills: CronAggregateBackfillWithLatestRun[];
};

/**
 * Describes the message chalk.aggregate.v1.GetActiveCronAggregateBackfillsResponse.
 * Use `create(GetActiveCronAggregateBackfillsResponseSchema)` to create a new message.
 */
export const GetActiveCronAggregateBackfillsResponseSchema: GenMessage<GetActiveCronAggregateBackfillsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 12);

/**
 * @generated from message chalk.aggregate.v1.CreateAggregateBackfillJobRequest
 */
export type CreateAggregateBackfillJobRequest = Message<"chalk.aggregate.v1.CreateAggregateBackfillJobRequest"> & {
  /**
   * @generated from field: repeated string features = 1;
   */
  features: string[];

  /**
   * @generated from field: optional google.protobuf.Timestamp lower_bound = 2;
   */
  lowerBound?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp upper_bound = 3;
   */
  upperBound?: Timestamp;

  /**
   * @generated from field: optional string resolver = 4;
   */
  resolver?: string;

  /**
   * @generated from field: optional string bucket_feature = 5;
   */
  bucketFeature?: string;

  /**
   * @generated from field: bool enable_profiling = 6;
   */
  enableProfiling: boolean;

  /**
   * @generated from field: optional string aggregate_backfill_id = 7;
   */
  aggregateBackfillId?: string;

  /**
   * @generated from field: optional string resource_group = 8;
   */
  resourceGroup?: string;

  /**
   * @generated from field: repeated string query_tags = 9;
   */
  queryTags: string[];

  /**
   * @generated from field: optional bool store_offline = 10;
   */
  storeOffline?: boolean;

  /**
   * @generated from field: optional bool use_metaplanner = 11;
   */
  useMetaplanner?: boolean;

  /**
   * @generated from field: optional bool allow_empty_tiles = 12;
   */
  allowEmptyTiles?: boolean;

  /**
   * @generated from field: optional bool store_online = 13;
   */
  storeOnline?: boolean;

  /**
   * @generated from field: optional string input_sql = 14;
   */
  inputSql?: string;

  /**
   * Split this backfill's window into this many bucket-aligned time-sharded
   * jobs. Unset/1 preserves the single-job behavior.
   *
   * @generated from field: optional int32 num_shards = 15;
   */
  numShards?: number;

  /**
   * Publish online summaries without implicitly writing ordinary online buckets.
   *
   * @generated from field: bool store_online_summaries = 16;
   */
  storeOnlineSummaries: boolean;
};

/**
 * Describes the message chalk.aggregate.v1.CreateAggregateBackfillJobRequest.
 * Use `create(CreateAggregateBackfillJobRequestSchema)` to create a new message.
 */
export const CreateAggregateBackfillJobRequestSchema: GenMessage<CreateAggregateBackfillJobRequest> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 13);

/**
 * @generated from message chalk.aggregate.v1.CreateAggregateBackfillJobResponse
 */
export type CreateAggregateBackfillJobResponse = Message<"chalk.aggregate.v1.CreateAggregateBackfillJobResponse"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;

  /**
   * @generated from field: repeated string features = 2;
   */
  features: string[];

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError errors = 3;
   */
  errors: ChalkError[];
};

/**
 * Describes the message chalk.aggregate.v1.CreateAggregateBackfillJobResponse.
 * Use `create(CreateAggregateBackfillJobResponseSchema)` to create a new message.
 */
export const CreateAggregateBackfillJobResponseSchema: GenMessage<CreateAggregateBackfillJobResponse> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 14);

/**
 * @generated from message chalk.aggregate.v1.CreateAggregateBackfillV2Request
 */
export type CreateAggregateBackfillV2Request = Message<"chalk.aggregate.v1.CreateAggregateBackfillV2Request"> & {
  /**
   * What to plan. Spelled out here rather than embedding AggregateBackfillUserParams so this
   * request can change independently of the planner's own input message, in either direction.
   *
   * @generated from field: repeated string features = 1;
   */
  features: string[];

  /**
   * @generated from field: optional string resolver = 2;
   */
  resolver?: string;

  /**
   * @generated from field: optional string input_sql = 3;
   */
  inputSql?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp lower_bound = 4;
   */
  lowerBound?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp upper_bound = 5;
   */
  upperBound?: Timestamp;

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[];

  /**
   * @generated from field: bool exact = 7;
   */
  exact: boolean;

  /**
   * How to run it, applied identically to every job produced by the plan.
   * Without another selected target, an unset store_online defaults to true.
   * All resolved targets false requests a dataset-only test run.
   *
   * @generated from field: optional bool store_online = 8;
   */
  storeOnline?: boolean;

  /**
   * @generated from field: optional bool store_offline = 9;
   */
  storeOffline?: boolean;

  /**
   * @generated from field: optional bool allow_empty_tiles = 10;
   */
  allowEmptyTiles?: boolean;

  /**
   * @generated from field: bool enable_profiling = 11;
   */
  enableProfiling: boolean;

  /**
   * @generated from field: optional string resource_group = 12;
   */
  resourceGroup?: string;

  /**
   * Same string-map spelling as artifacts.v1.CronAggregateBackfill.planner_options; the
   * server converts to the typed chalk.jobqueue.v1.PlannerOptions per job. Execution-only:
   * the planner does not accept planner options.
   *
   * @generated from field: map<string, string> planner_options = 13;
   */
  plannerOptions: { [key: string]: string };

  /**
   * @generated from field: chalk.aggregate.v1.AggregateBackfillMode mode = 14;
   */
  mode: AggregateBackfillMode;

  /**
   * Split each planned sub-backfill's window into this many bucket-aligned
   * time-sharded jobs. Unset/1 preserves the single-job behavior.
   *
   * @generated from field: optional int32 num_shards = 15;
   */
  numShards?: number;

  /**
   * Publish online summaries without implicitly writing ordinary online buckets.
   *
   * @generated from field: bool store_online_summaries = 16;
   */
  storeOnlineSummaries: boolean;
};

/**
 * Describes the message chalk.aggregate.v1.CreateAggregateBackfillV2Request.
 * Use `create(CreateAggregateBackfillV2RequestSchema)` to create a new message.
 */
export const CreateAggregateBackfillV2RequestSchema: GenMessage<CreateAggregateBackfillV2Request> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 15);

/**
 * @generated from message chalk.aggregate.v1.CreateAggregateBackfillV2Response
 */
export type CreateAggregateBackfillV2Response = Message<"chalk.aggregate.v1.CreateAggregateBackfillV2Response"> & {
  /**
   * Absent in plan mode. There is one aggregate_backfill_jobs row per aggregate backfill
   * id, so this is a single job even when the plan splits the request into N sub-backfills.
   *
   * @generated from field: optional chalk.aggregate.v1.AggregateBackfillJob job = 1;
   */
  job?: AggregateBackfillJob;

  /**
   * The planner's split of this request, named for the planner's own vocabulary: it
   * "splits backfill into sub-backfills".
   *
   * @generated from field: repeated chalk.aggregate.v1.AggregateBackfillWithCostEstimate sub_backfills = 2;
   */
  subBackfills: AggregateBackfillWithCostEstimate[];
};

/**
 * Describes the message chalk.aggregate.v1.CreateAggregateBackfillV2Response.
 * Use `create(CreateAggregateBackfillV2ResponseSchema)` to create a new message.
 */
export const CreateAggregateBackfillV2ResponseSchema: GenMessage<CreateAggregateBackfillV2Response> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_service, 16);

/**
 * Whether CreateAggregateBackfillV2 stops after planning or goes on to create jobs.
 *
 * @generated from enum chalk.aggregate.v1.AggregateBackfillMode
 */
export enum AggregateBackfillMode {
  /**
   * @generated from enum value: AGGREGATE_BACKFILL_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Plan only: return sub_backfills and create nothing.
   *
   * @generated from enum value: AGGREGATE_BACKFILL_MODE_PLAN = 1;
   */
  PLAN = 1,

  /**
   * Plan, then create a job for every sub-backfill.
   *
   * @generated from enum value: AGGREGATE_BACKFILL_MODE_CREATE = 2;
   */
  CREATE = 2,
}

/**
 * Describes the enum chalk.aggregate.v1.AggregateBackfillMode.
 */
export const AggregateBackfillModeSchema: GenEnum<AggregateBackfillMode> = /*@__PURE__*/
  enumDesc(file_chalk_aggregate_v1_service, 0);

/**
 * @generated from service chalk.aggregate.v1.AggregateService
 */
export const AggregateService: GenService<{
  /**
   * PlanAggregateBackfill determines the estimated resources needed to backfill
   * an aggregate.
   *
   * This method is a duplicate of the PlanAggregateBackfill method
   * in the query_server.proto file. We should remove the query_server.proto method
   * and move that request to this service instead.
   * buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   *
   * @generated from rpc chalk.aggregate.v1.AggregateService.PlanAggregateBackfill
   */
  planAggregateBackfill: {
    methodKind: "unary";
    input: typeof PlanAggregateBackfillRequestSchema;
    output: typeof PlanAggregateBackfillResponseSchema;
  },
  /**
   * This method is a duplicate of the PlanAggregateBackfill method
   * in the query_server.proto file. We should remove the query_server.proto method
   * and move that request to this service instead.
   * buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   *
   * @generated from rpc chalk.aggregate.v1.AggregateService.GetAggregates
   */
  getAggregates: {
    methodKind: "unary";
    input: typeof GetAggregatesRequestSchema;
    output: typeof GetAggregatesResponseSchema;
  },
  /**
   * @generated from rpc chalk.aggregate.v1.AggregateService.GetAggregateBackfillJobs
   */
  getAggregateBackfillJobs: {
    methodKind: "unary";
    input: typeof GetAggregateBackfillJobsRequestSchema;
    output: typeof GetAggregateBackfillJobsResponseSchema;
  },
  /**
   * @generated from rpc chalk.aggregate.v1.AggregateService.GetAggregateBackfillJob
   */
  getAggregateBackfillJob: {
    methodKind: "unary";
    input: typeof GetAggregateBackfillJobRequestSchema;
    output: typeof GetAggregateBackfillJobResponseSchema;
  },
  /**
   * @generated from rpc chalk.aggregate.v1.AggregateService.GetCronAggregateBackfill
   */
  getCronAggregateBackfill: {
    methodKind: "unary";
    input: typeof GetCronAggregateBackfillRequestSchema;
    output: typeof GetCronAggregateBackfillResponseSchema;
  },
  /**
   * @generated from rpc chalk.aggregate.v1.AggregateService.GetActiveCronAggregateBackfills
   */
  getActiveCronAggregateBackfills: {
    methodKind: "unary";
    input: typeof GetActiveCronAggregateBackfillsRequestSchema;
    output: typeof GetActiveCronAggregateBackfillsResponseSchema;
  },
  /**
   * Creates one backfill job for a single already-planned sub-backfill, so callers must
   * plan first and then call this once per planned sub-backfill.
   *
   * Prefer CreateAggregateBackfillV2, which does the planning and the fan-out server side.
   * Kept for clients pinned to versions that predate V2.
   *
   * @generated from rpc chalk.aggregate.v1.AggregateService.CreateAggregateBackfillJob
   */
  createAggregateBackfillJob: {
    methodKind: "unary";
    input: typeof CreateAggregateBackfillJobRequestSchema;
    output: typeof CreateAggregateBackfillJobResponseSchema;
  },
  /**
   * CreateAggregateBackfillV2 plans an aggregate backfill and, unless the request asks for
   * plan mode, creates the jobs for it. This replaces the client-side
   * plan-then-create-each-sub-backfill loop that PlanAggregateBackfill plus
   * CreateAggregateBackfillJob require.
   *
   * @generated from rpc chalk.aggregate.v1.AggregateService.CreateAggregateBackfillV2
   */
  createAggregateBackfillV2: {
    methodKind: "unary";
    input: typeof CreateAggregateBackfillV2RequestSchema;
    output: typeof CreateAggregateBackfillV2ResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_aggregate_v1_service, 0);

